import { FINDER } from "constants/constants"
import { AVAILABLE_CHAIN_ID } from "constants/networks"
import networks from "constants/networks"
import { useWallet } from "libs/CosmesWalletProvider"
import { useMemo } from "react"

const useNetwork = () => {
  const { network: extNetwork } = useWallet()

  // Use useMemo to prevent creating a new object on every render
  return useMemo(() => {
    const fallbackChainID = AVAILABLE_CHAIN_ID[0] || Object.keys(networks)[0]
    const chainID = extNetwork?.chainID || fallbackChainID
    const network = networks[chainID] || networks[fallbackChainID]

    const finder = (address: string, path: string = "account") =>
      `${FINDER}/${chainID}/${path}/${address}`

    return { ...extNetwork, ...network, finder }
  }, [extNetwork])
}

export default useNetwork
